import { CommonModule } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { MatDialogModule } from "@angular/material/dialog";

import { ToastrModule } from "ngx-toastr";

import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeScreenComponent } from "./welcome/home-screen/home-screen.component";
import { SharedModule } from './shared/shared.module';
import { BancassuranceProducteurTransfertsinistreComponent } from './welcome/home-menu/bancassurance-producteur-transfertsinistre/bancassurance-producteur-transfertsinistre.component';
import { ModalTransferClaimComponent } from './welcome/home-menu/bancassurance-producteur-transfertsinistre/modal-transferclaim.component';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MiddlemanInterceptor } from "./_interceptors/middleman.interceptor";
import { WebcamModule } from "ngx-webcam";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from "@angular/material/autocomplete";
import { MAT_SELECT_SCROLL_STRATEGY_PROVIDER } from "@angular/material/select";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "./assets/i18n/", ".json");
}

import { Overlay, CloseScrollStrategy } from "@angular/cdk/overlay";

export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
  return () => overlay.scrollStrategies.close();
}

@NgModule({
  declarations: [AppComponent, HomeScreenComponent, BancassuranceProducteurTransfertsinistreComponent, ModalTransferClaimComponent],
  entryComponents: [ModalTransferClaimComponent],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot({
      preventDuplicates: true,
    }), // ToastrModule added
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    // Material modules
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    WebcamModule,
    MatProgressSpinnerModule,
    SharedModule,


  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MiddlemanInterceptor,
      multi: true,
    },
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: scrollFactory,
      deps: [Overlay],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
